/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

 import { Code, Confirm } from 'src/refresh/service/constant';
 import { GAData } from '../constant/page-const';
 declare let gtag: any;
 export class PageConstComponent {

      public  NotFound:any = Code.NotFound;

      //public Button:Object = Button;
      public Button = { 
            Next:       "button.next" , 
            Next_alt:   "button.next_alt", 
            Payment_alt:   "button.payment_alt", 
            Previous:   "button.prev", 
            Cancel:     "button.cancel", 
            Cancel_alt: "button.cancel_alt", 
            START:      "button.get_started" ,
            START_alt:  "button.get_started_alt", 
            Agree:      "button.agree" ,
            Agree_alt:  "button.agree_alt",
            Back_alt:   "button.back_alt",
            Close:      "button.close"
      }

      public YES = 'Y';
      public NO  = 'N';

      public GA:GAData = GAData;

      public gtag(action:string, value:LabelGroup) {
             
             gtag('event', action, {
                  'event_label'   : value.label,
                  'event_category': value.group
             });                 
      }
 } 

  
 export interface LabelGroup {
      label:string;
      group:string;
 }

 export interface GAData {
      Button:string;
      Link:string;
      Image:string;
  
      email_receipt:LabelGroup;
      download_receipt:LabelGroup;
      FAQ_registration:LabelGroup;
  
      FAQ_Certificate:LabelGroup;
      FAQ_CCB:LabelGroup;
      FAQ_SIN:LabelGroup;
      FAQ_ESR:LabelGroup;
      Progress_Bar:LabelGroup;
  
      BC_parental:LabelGroup;
      Birth_Certificate:LabelGroup;
      onca_Newborn:LabelGroup;
      email_ORG:LabelGroup;
      cancel_app:LabelGroup;
      switch_pounds:LabelGroup;
      continue_product:LabelGroup;
      no_BC:LabelGroup;
      whatIf_no_BC:LabelGroup;
      whatIf_no_additional:LabelGroup;
      back_areYouSure:LabelGroup;
      returnTo_BC:LabelGroup;
      statement_LB:LabelGroup;
      no_RESP:LabelGroup;
      returnTo_onca:LabelGroup;
      OHIP:LabelGroup;
      Vaccines:LabelGroup;
      Childhood:LabelGroup;
      find_childcare:LabelGroup;
      Indian:LabelGroup;
      child_deceased:LabelGroup;
   }

